import actions from '@/store/rushes/actions';

const rushesModule = {
  state: () => ({
    rushes: [],
  }),
  getters: {
    sortedRushes(state) {
      return state.rushes ? state.rushes.sort((a, b) => a.percent - b.percent) : [];
    },
  },
  mutations: {
    GET_RUSHES_SUCCESS(state, data) {
      state.rushes = data;
    },
  },
  actions,
  namespaced: true,
};

export default rushesModule;
